import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import ErrorMessage from "component/common/ErrroMessage/index";

import styles from "./RejectPopup.module.scss";

const RejectPopup = ({ isOpen, toggle, onReject }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    onReject(data.reason);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <div className={styles.reject_popup}>
          <div className={styles.title}>
            <b>REJECT REASON</b>
          </div>
          <div>
            <textarea
              {...register("reason", { required: true })}
              style={{ borderColor: errors.reason ? "#f90500" : "#c4c4c4" }}
            />
            <ErrorMessage
              error={errors.reason}
              message={{ required: "Please enter reason" }}
            />
          </div>
          <div className={styles.reject_popup_btn}>
            <button className={styles.cancel} onClick={() => toggle()}>
              Cancel
            </button>
            <button className={styles.reject} onClick={handleSubmit(onSubmit)}>
              Reject
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RejectPopup;
